import React from 'react';
import { styled } from '@ringcentral/juno';
import { Permissions } from '@/components/profileDetail/profileBody/technicalDetails/permissions';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 58px;
`;

export const TechnicalDetails = () => {
  return (
    <Wrapper>
      <Permissions />
    </Wrapper>
  );
};
